import * as m from 'mithril';
import * as dayjs from 'dayjs';
import SearchCriteria, { TravellerType } from './../models/SearchCriteria';
import OptionList from './OptionList';
import SpinnerBox from './SpinnerBox';
import { DateChooserDialog } from './Calendar';
import { MessageProvider } from '../context/AppMessages';
import './SearchForm.scss';
import SearchFormModel, { FieldError } from '../models/SearchFormModel';
import { getIntlStringValue } from '../helpers/StringHelpers';
import CustomSvgIcon from './CustomSvgIcon';

interface Attrs {
    messageProvider: MessageProvider,
    isSearchingSmallCar: boolean,
    formModel: SearchFormModel,
    onSourceLocationClick: () => void,
    onDestinationLocationClick: () => void,
    onSearchClick: (searchCritiera: SearchCriteria) => void
}

function getFieldErrorClassOnError(fieldName: string, fieldErrors: FieldError[]): string {
    if (fieldErrors.length > 0) {
        let fieldError = fieldErrors[0];
        if (fieldError.name == fieldName) {
            return " glowing-field ";
        }
    }
    return "";
}

function 
SearchForm(): m.Component<Attrs> {
    let isSelectingDate: boolean = false;
    let lastFormFieldErrors: FieldError[] = [];
    let shouldAnimate = false;
    let animationClassName = ""

    return {

        view(vnode) {
            const formModel = vnode.attrs.formModel;
            const messageProvider = vnode.attrs.messageProvider;
            const currLang = messageProvider.getCurrentLang();
            animationClassName = shouldAnimate? ( vnode.attrs.isSearchingSmallCar? "animation delay1" : "animation2 delay1" ) : "";

            return m("div", { class: "form m-3" }, [
                // Location From To
                m("div", { class: "card shadow-sm" }, [
                    m("div", {
                        class: "row px-2 justify-content-center " + animationClassName,
                        style: "position:relative"
                    }, [
                        m("div", {
                            class: "col-6 p-3 text-center text-truncate border-right clickable" + getFieldErrorClassOnError('source', lastFormFieldErrors),
                            onclick: () => {
                                vnode.attrs.onSourceLocationClick();
                                lastFormFieldErrors = [];
                            }
                        }, [
                            (formModel.sourceLocation) ?
                                getIntlStringValue(formModel.sourceLocation.name, currLang)
                                
                                : m("span", { class: "text-muted" }, messageProvider.get("location_from")),

                            m("div", { class: "text-center" }, [

                                m(CustomSvgIcon, {
                                    iconType: 'caret_arrow_down',
                                    themeCssClass: "svg-info svg-small"
                                })
                            ])
                        ]),

                        m("div", {
                            class: "col-6 p-3 text-center text-truncate clickable" + getFieldErrorClassOnError('destination', lastFormFieldErrors),
                            onclick: () => {
                                if (vnode.attrs.formModel.sourceLocation) {
                                    vnode.attrs.onDestinationLocationClick();
                                    lastFormFieldErrors = [];
                                } else {
                                    lastFormFieldErrors = [{ name: 'source' }];
                                }
                            }
                        }, [
                            (formModel.destinationLocation) ?
                                getIntlStringValue(formModel.destinationLocation.name, currLang)
                                //(messageProvider.getCurrentLang() == "en") ? formModel.destinationLocation.nameEN : formModel.destinationLocation.nameMM

                                : m("span", { class: "text-muted" }, messageProvider.get("location_to")),

                            m("div", { class: "text-center" }, [
                                m(CustomSvgIcon, {
                                    iconType: 'caret_arrow_down',
                                    themeCssClass: "svg-info svg-small"
                                })
                            ])
                        ]),

                        m("div", { class: "d-flex align-self-center position-absolute" },
                            m(CustomSvgIcon, {
                                iconType: 'long_arrow_alt_right',
                                themeCssClass: "svg-info svg-large"
                            })
                        )

                    ]),
                ]),
                // Location From To end

                // Date
                m("div", {
                    class: "card shadow-sm clickable mt-3 " + animationClassName,
                }, [
                    m("div", {
                        class: "card-body py-3" + getFieldErrorClassOnError('departureDate', lastFormFieldErrors),
                        onclick: (event) => {
                            isSelectingDate = true;
                        }
                    }, m("div.row", {},
                        [
                            m("div.col-2", { class: "text-center" },
                                m(CustomSvgIcon, {
                                    iconType: "calendar",
                                    themeCssClass: "svg-medium svg-info"
                                })
                            ),
                            m("div.col-8", { class: "col text-center" },
                                [
                                    (formModel.departureDate) ?
                                        m('span', { class: 'ml-2' }, dayjs(formModel.departureDate).format("MMMM D, dddd")) :
                                        m('span', { class: 'ml-2 text-muted' }, messageProvider.get("departure_date"))
                                ])
                        ]
                    )),

                    m(DateChooserDialog, {
                        isOpen: isSelectingDate,
                        selectedDate: (formModel.departureDate) ? formModel.departureDate : null,
                        minDate: dayjs(new Date()).format('YYYY-MM-DD'),
                        maxDate: dayjs(new Date()).add(42, 'day').format('YYYY-MM-DD'),
                        onDateSelected: (date: string) => {
                            isSelectingDate = false;
                            formModel.departureDate = date;
                            // attrs.onDateSelected(date);
                            lastFormFieldErrors = [];
                        },
                        onClose: () => {
                            isSelectingDate = false;
                            console.log("on close is called");
                        }
                    })
                ]),
                // Date End

                // Seat
                m("div", { class: "mt-3 " },
                    [
                        m(SpinnerBox, {
                            singularLabel: messageProvider.get("seat"),
                            pluralLabel: messageProvider.get("seats"),
                            initialValue: formModel.numberOfSeats,
                            minCount: 1,
                            maxCount: 4,
                            onCountChange: function (newValue) {
                                formModel.numberOfSeats = newValue;
                            }
                        })
                    ]
                ),
                // Seat End

                // Type
                m("div", { class: "mt-3" + getFieldErrorClassOnError('travellerType', lastFormFieldErrors) },
                    [
                        m(OptionList, {
                            initialValue: formModel.travellerType,
                            options: [
                                { value: "Local", label: messageProvider.get("local") },
                                { value: "Foreigner", label: messageProvider.get("foreigner") }
                            ],
                            onOptionSelected: function (option) {
                                formModel.travellerType = <TravellerType>option.value;
                                lastFormFieldErrors = [];
                            }
                        })
                    ]
                ),
                // Type end

                // Search Btn
                m("div", { class: "mt-4" },
                    m("button", {
                        class: "btn btn-lg btn-block btn-primary shadow-sm",
                        onclick: function (event) {
                            event.preventDefault();
                            lastFormFieldErrors = formModel.validate();
                            if (lastFormFieldErrors.length == 0) {
                                let searchCriteria = formModel.toSearchCriteria(vnode.attrs.isSearchingSmallCar);
                                console.log("new criteria", searchCriteria);
                                vnode.attrs.onSearchClick(searchCriteria);
                            } else {
                                console.log("Form has errors", lastFormFieldErrors);
                                if(navigator.vibrate) {
                                    navigator.vibrate(50);
                                }
                            }
                        }
                    }, messageProvider.get("search_now"))
                )
            ]);
        }
    }
}


export { SearchForm, SearchFormModel };